'use client'
import styled from "styled-components"
import { useTranslator } from "@/hooks"
import { mq, vw } from "@/styles"

export default function NotFoundLang() {
  const { t } = useTranslator()
  return (
    <Main>
      <Section>
        <h1>{t('commons.page_not_found.title')}</h1>
        <p>{t('commons.page_not_found.description')}</p>
      </Section>
    </Main>
  )
}


const Main = styled.main`
  align-items: center;
  background-color: #274943;
  color: white;
  display: flex;
  flex-direction: row;
  height: 100dvh;
  height: 100vh;
  justify-content: center;
  left: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  width: 100dvw;
  width: 100vw;
`

const Section = styled.section`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  text-align: left;
  padding: ${vw(15, 'mobile')} ${vw(17, 'mobile')};
  width: 90%;

  ${mq.greaterThan('tablet')} {
    padding:${vw(25, 'desktop')} ${vw(50, 'desktop')};
  }

  ${mq.greaterThan('desktop')} {
    padding: 25px 50px;
  }

  h1,
  p {
    text-align: center;
    width: 100%;
  }

  h1 {
    margin-bottom: ${vw(25, 'mobile')};

    ${mq.greaterThan('tablet')} {
      margin-bottom: ${vw(25, 'desktop')};
    }

    ${mq.greaterThan('desktop')} {
      margin-bottom: 25px;
    }
  }
`
